export const meQueryKeys = {
  all: ['me'] as const,
  memberships: () => [...meQueryKeys.all, 'memberships'] as const,
} as const;
